import React from 'react';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';

class SMUSettingEditVerificationFragmentView extends SMUSettingEditBaseFragment {
  
  constructor(props) {
    super(props);

    this.formRequest = null;
    this.state = {
      user: this.props.user,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000500'));
    
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  fileDidUpload(e) {
    if (!e.currentTarget.files.length) return;
    let file = e.currentTarget.files[0],
        fileReader = new FileReader();
    fileReader.onload = (e)=>{
      let formData = new FormData(this.refs.form);
      if (this.formRequest) this.formRequest.abort();
      this.formRequest = SMUserResource.updateUser(formData, {}, (user, error, xhr)=>{
        this.formRequest = null;
        if (error) {
          this.setState({errors: xhr.responseJSON.errors});
          return;
        } else if (xhr.status == 200) {
          this.setState({
            user: user,
            errors: []
          });
          this.props.delegate.showSuccessMessage();        
        }
      });
    };
    fileReader.readAsDataURL(file);
  }
  
  formDidSubmit(e) {
    e.preventDefault();
    this.formRequest = SMUserResource.requestReviewCertificate({}, (user, error, xhr)=>{
      this.formRequest = null;
      if (error) {
        this.setState({errors: xhr.responseJSON.errors});
        return;
      } else if (xhr.status == 200) {
        this.setState({ user: user, errors: [] });
        this.props.delegate.showSuccessMessage();        
      }
    });
  }
  
  onClick(e) {
    e.preventDefault();
    this.refs.inputFile.click();
  }
  
  renderCertificate() {
    if (!this.state.user.certificate.url) {
      return(
        <div className="form-box">
          <form ref='form'>
            <input ref='inputFile' type="file" name="certificate" id="files" onChange={this.fileDidUpload.bind(this)} hidden />
            <label htmlFor="files" className="button-gray pt10 pb10 w180 mr10">
              <i className="fa fa-paperclip"></i> ファイルを選択
            </label>
            <input type="submit" disabled="disabled" className="button button-disabled pt10 pb10 w130 ml5" value="認証する" />
          </form>
        </div>
      );
    } else {
      if (this.state.user.is_certificated) {
        return(
          <div className="form-box">
            認証済みです。
          </div>
        );
      } else {
        if (this.state.user.certificate_status == SMConst.CertificationStatus.Rejected) {
          return(
            <div className="form-box">
              <form ref='form'>
                <input ref='inputFile' type="file" name="certificate" id="files" onChange={this.fileDidUpload.bind(this)} hidden />
                <span className="is-error">アップロードした画像では認証できませんでした。再度アップロードしてください。</span>
                <a onClick={this.onClick.bind(this)} className="ml10 link-hover-border">画像を再登録する</a>
              </form>
            </div>
          );
        } else if (this.state.user.certificate_status == SMConst.CertificationStatus.Requested) {
          return(
            <div className="form-box">
              アップロードした画像をスペースマーケットにて確認中です。しばらくお待ちください。
            </div>
          );
        } else {
          return(
            <div className="form-box">
              <form ref='form' onSubmit={this.formDidSubmit.bind(this)}>
                <input type="file" name="certificate" id="files" onChange={this.fileDidUpload.bind(this)} hidden />
                <label htmlFor="files" className="button-gray pt10 pb10 w180 mr10">
                  <i className="fa fa-paperclip"></i> ファイルを変更
                </label>
                <span className="mr20">{this.state.user.certificate.name}</span>
                <input type="submit" className="button button-blue pt10 pb10 w130 ml5" value="認証する" />
              </form>
            </div>
          );
        }
      }
    }
  }

  render() {
    return(
      <div style={this.fragmentStyle()}>
        <p className="dashboard-lead">公的な情報を登録することで認証済みアカウントとなり、ホストのからの信用が高まります。なるべく多くの認証情報を登録しましょう。</p> 
        <h2 className="dashboard-title mb20">
          パスポート<br />
          <span className="dashboard-title__supplement">
            パスポートを登録しましょう。記載内容がはっきり分かる画像をアップロードしてください。この情報は民泊をする際には必須となります。
          </span>
        </h2>
        {this.renderCertificate()}
      </div>
    );
  }
}
export default SMUSettingEditVerificationFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditVerificationFragmentView.jsx